import { useEffect, useState } from "react";
import api from "./api";
import { DEPARTURES_2027 } from "../data/holidays";

let cache = null;
let inflight = null;

const merge = (seats) => DEPARTURES_2027.map((d) => (seats[d.id] !== undefined ? { ...d, seatsLeft: seats[d.id] } : d));

// 2027 departures = static calendar (dates) + admin-managed seatsLeft overrides, fetched once per page load.
export function useDepartures() {
  const [list, setList] = useState(cache || DEPARTURES_2027);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || api.get("/settings/departures").then((r) => { cache = merge(r.data.seats || {}); return cache; }).catch(() => DEPARTURES_2027);
    inflight.then(setList);
  }, []);
  return list;
}
